/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/3
 * @updateTime 2021/9/3
 * @decription 申请担保-上传材料相关处理js
 * @namespace 【sccl】
 */
import {
    // 删除人员文件
    delPersonFile
} from '@/api/guarantee';
// 文件上传组件
import acUploadFile from '@/components/app/upload-file/index.vue';
export default {
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acUploadFile
    },
    // 数据
    data() {
        return {
            // 上传材料数据
            scclData: {},
            // 上传材料url
            scclUploadUrl: 'commonapi/api/bgdb/fileupload',
            // 删除材料url
            scclDeleteUrl: 'commonapi/api/bgdb/delfile',
            // 上传材料是否加载完成
            scclLoaded: false
        };
    },
    computed: {
        // 删除材料接口参数
        scclDeleteParam() {
            return {
                // 担保id
                dbid: this.dbid
            };
        },
        //上传材料id属性
        scclIdProp() {
            return this.fromSQBG ? 'cDbclid' : 'cId';
        }
    },
    // 方法
    methods: {

        /**
         * 初始化上传材料数据
         * @param {Object} data 上传材料数据
         * @returns {void}
         * */
        initScclData(data) {
            // 上传材料数据转换
            this.scclTransform(data);
            // 上传材料赋值
            this.scclData = data;
            // 上传材料加载完成
            this.scclLoaded = true;
            // 上传材料同步申请人数据
            this.scclSyncSqrData();
            // 上传材料同步被申请人数据
            this.scclSyncBsqrData();
            // 上传材料同步代理人数据
            this.scclSyncDlrData();
        },

        /**
         * 上传材料数据转换
         * @param {Object} data 上传材料数据
         * @returns {void}
         * */
        scclTransform(data) {
            Object.keys(data).forEach(key => {
                this.scclHandlerFileName(data[key]);
            })
        },

        /**
         * 上传材料添加对应的文件信息
         * @param {Object} fileItem 文件信息项
         * @returns {void}
         * */
        scclAddFileInfo(fileItem) {
            fileItem.file = {
                // 对应的材料名称
                name: fileItem.cSqdbclmc
            }
        },

        /**
         * 处理变更担保申请书中的文件名称
         * @param {Array<Object>} fileList 文件数据列表
         * @returns {void}
         * */
        scclHandlerFileName(fileList) {
            if (!fileList || !fileList.length) {
                return;
            }
            fileList.forEach(fileItem => {
                // 如果存在url数据，则说明是上传材料
                if (fileItem.url) {
                    this.scclAddFileInfo(fileItem);
                } else if (fileItem.clList) {
                    this.scclHandlerFileName(fileItem.clList);
                }
            });
        },


        /**
         * 人员id
         * @param {String} ryid 人员id
         * @returns {void}
         * */
        scclSfzmlUploadParam(ryid) {
            /**
             * 返回方法动态获取
             * @param {BinaryType} file 文件流
             * @param {String} cId 文件id
             * @param {FormData} 表单数据
             * @returns {Object} 对象
             * */
            return (file, cId, formData) => {
                // 组件默认会塞入file，此处参数名是files
                formData.delete('file');
                return {
                    // 人员id
                    id: ryid,
                    // 文件二进制流
                    files: file,
                    // 担保id
                    dbid: this.dbid,
                    // 材料类型
                    cllx: 3
                }
            }
        },

        /**
         * 获取上传材料参数
         * @param {Number} cllx
         * @returns {Function}
         * */
        scclUploadParam(cllx) {
            /**
             * 返回方法动态获取
             * @param {BinaryType} file 文件流
             * @param {String} cId 文件id
             * @param {FormData} 表单数据
             * @returns {Object} 对象
             * */
            return (file, cId, formData) => {
                // 组件默认会塞入file，此处参数名是files
                formData.delete('file');
                return {
                    files: file,
                    // 担保id
                    dbid: this.dbid,
                    // 材料类型
                    cllx: cllx
                }
            }
        },

        /**
         * 获取上传材料数据
         * @returns {void}
         * */
        scclGetData() {
            this.requestFySCCL({
                // 复议id
                fyid: this.fyid
            }).then((res) => {
                // 赋值上传材料数据
                this.scclData = res.data;
                // 上传材料加载完成
                this.scclLoaded = true;
            })
        },

        /**
         * 获取上传文件数据
         * @param {Object} resData 请求返回数据
         * @param {Object} fileData 上传组件对应数据
         * @returns {Object} 处理之后的上传文件
         * */
        scclGetUploadFileData(resData, fileData) {
            return {
                // 将返回数据与组件数据进行合并
                ...resData.dbSqcl,
                ...fileData
            };
        },

        /**
         * 通过人员id删除身份证明材料
         * @param {String} ryId 人员id
         * @returns {void}
         * */
        scclDelByRyId(ryId) {
            // 身份证明类材料
            const _fileList = this.scclData.sfzml;
            if (!_fileList.length) {
                return;
            }
            // 找到文件进行删除
            _fileList.some((fileItem, index) => {
                // 人员id一致，则进行数据删除
                if (ryId === fileItem.ryid) {
                    // 先删除对应的文件列表
                    this.scclDeleteSfzmlFile(fileItem);
                    _fileList.splice(index, 1);
                    return true;
                }
                return false;
            });
        },

        /**
         * 删除身份证明类材料
         * @param {Object} ryItem 人员信息项数据
         * @returns {void}
         * */
        scclDeleteSfzmlFile(ryItem) {
            // 只有新增的人员需要同步删除对应的材料
            if (!ryItem.isAdd) {
                return;
            }
            // 调用删除人员材料接口
            delPersonFile({
                dbid: this.dbid,
                bgcs: this.basicPostData.nSfbgwc,
                ryid: ryItem.ryid
            }).then(() => {
                console.log('删除人员材料成功！');
            })
        },

        /**
         * 通过人员id同步对应的人员名称
         * @param {String} ryId 人员id
         * @param {String} ryMc 人员名称
         * @param {Number} index 插入索引
         * @param {Number} isCheck 是否校验 0 不用校验 1 校验 被申请人是0 申请人和代理人是1
         * @returns {void}
         * */
        scclSyncDataByRyId(ryId, ryMc, index, isCheck = 1) {
            // 身份证明类材料
            const _fileList = this.scclData.sfzml;
            // 找到文件进行名称修改
            const _flag = _fileList.some(fileItem => {
                // 人员id一致，则进行数据修改
                if (ryId === fileItem.ryid) {
                    fileItem.rymc = ryMc;
                    return true;
                }
                return false;
            });
            // 如果不存在对应的人员id记录，则需要进行添加
            if (!_flag) {
                // 人员信息项数据
                const _ryItem = {
                    // 人员id
                    ryid: ryId,
                    // 人员名称
                    rymc: ryMc,
                    // 材料列表
                    clList: [],
                    // 是否校验
                    isCheck: isCheck,
                    // 是否是新增的人员
                    isAdd: true
                };
                // 如果存在索引，则直接插到到对应的索引
                // 否则插入到最后
                if (isNaN(index)) {
                    _fileList.push(_ryItem);
                } else {
                    _fileList.splice(index, 0, _ryItem);
                }
            }
        },

        /**
         * 上传材料同步申请人数据
         * @returns {void}
         * */
        scclSyncSqrData() {
            // 如果上传材料请求或者申请人请求未加载完成，则直接退出
            if (!this.scclLoaded || !this.sqrLoaded) {
                return;
            }
            // 遍历申请人列表，同步申请人信息
            this.sqrDataList.forEach((sqrItem, index) => {
                this.scclSyncDataByRyId(sqrItem[this.sqrIdProp], this.sqrGetScclName(sqrItem), index, 1);
            });
        },

        /**
         * 上传材料同步被申请人数据
         * @returns {void}
         * */
        scclSyncBsqrData() {
            // 如果上传材料请求或者被申请人请求未加载完成，则直接退出
            if (!this.scclLoaded || !this.bsqrLoaded) {
                return;
            }
            const _index = this.sqrDataList.length;
            // 遍历被申请人列表，同步被申请人信息
            this.bsqrDataList.forEach((bsqrItem, index) => {
                this.scclSyncDataByRyId(bsqrItem[this.bsqrIdProp], this.bsqrGetScclName(bsqrItem), _index + index, 0);
            });
        },

        /**
         * 上传材料同步代理人数据
         * @returns {void}
         * */
        scclSyncDlrData() {
            // 如果上传材料请求或者代理人请求未加载完成，则直接退出
            if (!this.scclLoaded || !this.dlrLoaded) {
                return;
            }
            const _index = this.sqrDataList.length + this.bsqrDataList.length;
            // 遍历代理人列表，同步代理人信息
            this.dlrDataList.forEach((dlrItem, index) => {
                this.scclSyncDataByRyId(dlrItem[this.dlrIdProp], this.dlrGetScclName(dlrItem), _index + index, 1);
            });
        }
    }
};
